/**
 * Vendors ´Dummy Mobiscroll´
 */

import SelectorEngine from '../../../../shared/dom/selector-engine';
import Manipulator from '../../../../shared/dom/manipulator';
import Data from "../../../../shared/dom/data";
import EventHandler from "../../../../shared/dom/event-handler";
import {loadScript} from "../../../../shared/utils/load-script";
import {extend, needJquery} from "../../../../shared/utils";
import AjaxRequest from "../../../../shared/utils/ajax";
import {isElement} from "../../../../shared/utils/is";


// -------
// Private
// -------

const $ = needJquery();

const now       = new Date();
const today     = new Date(now.setMinutes(59));
const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
const start     = now;
const end       = new Date(now.getDate() + 2);

const NAME      = 'mobi-calendar';
const DATA_KEY  = `ifab.${NAME}`;
const EVENT_KEY = `.${DATA_KEY}`;
const API_KEY   = `${DATA_KEY}.data-api`;

const DEFAULTS = {
	// theme: 'ios',
	// themeVariant: 'light',
	view: {
		schedule: {
			type                : 'day',
			startDay            : 1,
			endDay              : 1,
			startTime           : '08:00',
			endTime             : '20:00',
			allDay              : false,
			currentTimeIndicator: false,
			maxEventStack		: 10
		},
	},
	invalid: [
		{
			recurring: {
				repeat: 'daily',
				until: today,
			},
		},
		{
			start: start,
			end: end,
		},
	],
	eventOverlap : false,
	externalDrop: false,
	externalDrag: false,
	dragToCreate: false,
	dragToMove: false,
	resources : [
		{id: 1, name: 'Yvonne Thamm', color: 'var(--wp-color-grey-light)', type: 'verified'},
		{id: 2, name: 'Erik Reuter', color: 'var(--wp-color-grey-light)', type: 'verified'},
		{id: 3, name: 'Tobias Garz', color: 'var(--wp-color-grey-light)', type: 'alias'},
		{id: 4, name: 'Ralph Kropp', color: 'var(--wp-color-grey-light)', type: 'alias'}
	]
};

function MobiScheduler(element, o) {
	if (!isElement(element)) {
		return null;
	}

	this._elements = {
		container: element,
		calendar : SelectorEngine.findOne('.mobi-calendar', element) ?? SelectorEngine.findOne('.mobi-calendar', element),
		events   : SelectorEngine.findOne('.mobi-events > #md-docs-tasks', element) ?? SelectorEngine.findOne('.mobi-calendar', element),
		tooltip  : mobiscroll.popup('#mobi-tooltip-popup', {
			contentPadding: false,
			display       : 'anchored',
			scrollLock    : false,
			showOverlay   : false,
			touchUi       : false,
			width         : 350,
			id            : '#mobi-tooltip-popup'
		})
	};

	// API-Zugriffsmöglichkiten
	const api = {
		render      : this.renderCalendar.bind(this),
		createEvents: this.createEvents.bind(this)
	};

	// API im Container verfügbar machen
	Data.set(this._elements.container, API_KEY, api);

	// Initialisierungsstatus setzen.
	Data.set(this._elements.container,`${DATA_KEY}.initialized`, true);

	this.renderCalendar();

	return api;
}

MobiScheduler.prototype.renderCalendar = function() {
	const tooltip = this._elements.tooltip;

	this.options = extend({}, DEFAULTS, {
		showEventTooltip: false,
		onEventClick: function(args) {
			openTooltip(args, tooltip);
		}
	});

	mobiscroll.setOptions({
		locale: mobiscroll.localeDe,
		theme: 'ios',
		themeVariant: 'light'
	});

	this.createEvents();
};

MobiScheduler.prototype.createEvents = function() {
	let o              = {
		url       : './dist/default/vendors/mobiscroll/json/event.json',
		dataType  : 'json',
		method    : 'get',
		success   : (eventData, status, xhr) => {
			if(eventData && eventData.length) {
				this.options = extend({}, {data: eventData}, this.options);

				this.api = mobiscroll.eventcalendar(this._elements.calendar, this.options);
			}
		},
		error: (data, status, xhr) => {
			return false;
		},
	};

	const Request = new AjaxRequest(o);

	Request.init();
};

const openTooltip = (args, tooltip) => {
	tooltip.setOptions({anchor: args.domEvent.target.closest('.mbsc-schedule-event')});

	let _tooltipContainer = SelectorEngine.findOne(tooltip.props.id);
	let _toastContainer   = SelectorEngine.findOne('.toast', _tooltipContainer);
	let _header           = SelectorEngine.findOne('.toast-header', _toastContainer);
	let _body             = SelectorEngine.findOne('.toast-body', _toastContainer);
	let _footer           = SelectorEngine.findOne('.toast-footer', _toastContainer);

	_header.innerHTML = '';
	_body.innerHTML = '';
	_footer.innerHTML = '';

	let eventArgs       = args.event;
	let participantArgs = args.resourceObj;

	let event = {
		"id"      : eventArgs.id ? eventArgs.id : false,
		"title"   : eventArgs.title ? eventArgs.title : 'Unbenannter Block',
		"start"   : eventArgs.start ? eventArgs.start : false,
		"end"     : eventArgs.end ? eventArgs.end : false,
		"seats"   : eventArgs.seats ? parseInt(eventArgs.seats) : 0,
		"waitlist": eventArgs.waitlist ? eventArgs.waitlist : 0,
		"status"  : eventArgs.status ? eventArgs.status : false,
		"location": eventArgs.location ? eventArgs.location : false,
		"inCart"  : eventArgs.inCart ? eventArgs.inCart : false
	};

	let participant = {
		id  : participantArgs.id,
		name: participantArgs.name,
		type: participantArgs.type
	};

	let formatDate       = mobiscroll.formatDate;
	let time             = formatDate('HH:mm', new Date(event.start)) + ' - ' + formatDate('HH:mm', new Date(event.end));
	let date             = formatDate('DD.MM.YYYY', new Date(event.start));
	let seatsStr         = `${event.seats} Plätze`;
	let buttonBookingStr = `Platz buchen`;
	let eventClass       = 'success';
	let bookingPossible  = !event.inCart ?? true;

	if(!event.seats) {
		if(event.waitlist) {
			seatsStr         = `${event.waitlist} Warteplätze`;
			buttonBookingStr = `Warteplatz buchen`;
			eventClass       = 'warning';
		} else {
			seatsStr        = `ausgebucht`;
			eventClass  = 'danger';
			bookingPossible = false;
		}
	}

	// render Toast Header
	_header.innerHTML = `<div style="width:100%;" class="d-flex align-items-center justify-content-between"><span><strong>${event.title}</strong></span><span class="badge -white">${seatsStr}</span></div>`;

	// render Toast Body
	const _bodyInfos = Manipulator.createElementFrom('<div class="infos">');
	_bodyInfos.innerHTML = `<ul class="list -unstyled">
		<li><i class="fa-regular fa-user"></i> <strong>${participant.name}</strong></li>
		<li><i class="fa-regular fa-calendar"></i> ${date}</li>
		<li><i class="fa-regular fa-clock"></i> ${time}</li>
		<li><i class="fa-regular fa-location-pin"></i> ${event.location}</li>
	</ul>`;

	Manipulator.elementAppend(_bodyInfos, _body);

	// render Toast Footer
	if(bookingPossible) {
		const _buttonBooking = Manipulator.createElementFrom(`<button type="button" class="button -${eventClass} -s"><span class="button__label">${buttonBookingStr}</span></button>`);

		EventHandler.on(_buttonBooking, 'click', (ev) => {
			args.event.color     = `var(--wp-color-${eventClass})`;
			args.event.confirmed = true;
			args.event.cssClass  = '-in-cart';
			args.event.inCart    = true;

			if(event.waitlist) {
				args.event.waitlist = event.waitlist - 1;
			} else {
				args.event.seats = event.seats - 1;
			}

			args.inst.updateEvent([args.event]);

			tooltip.close();
		});

		Manipulator.elementAppend(_buttonBooking, _footer);
	} else if(event.inCart) {
		const _buttonDeleteBooking = Manipulator.createElementFrom(`<button type="button" class="button -danger -s"><span class="button__label">Buchung entfernen</span></button>`);

		EventHandler.on(_buttonDeleteBooking, 'click', (ev) => {
			args.event.confirmed = false;
			args.event.cssClass  = '';
			args.event.inCart    = false;
			if(event.waitlist) {
				args.event.waitlist = event.waitlist + 1;
			} else {
				args.event.seats = event.seats + 1;
			}

			args.inst.updateEvent([args.event]);

			tooltip.close();
		});

		Manipulator.elementAppend(_buttonDeleteBooking, _footer);
	}

	const _buttonDetails = Manipulator.createElementFrom(`<a class="event-control__item-link icon-link" data-bind="tooltip" data-control="detail" data-src="detail_modal-20.html?nd=1" data-href="detail_modal-20.html?nd=1" href="detail_modal-20.html?nd=1" data-type="iframe" data-fancybox="" title="Detailinformationen"><span class="icon-link__icon"><i class="far fa-info-circle "></i></span><span class="icon-link__label">Details</span></a>`);

	Manipulator.elementPrepend(_buttonDetails, _footer);

	tooltip.open();
};


// -------
// Public
// -------

const init = () => {
	const collection = SelectorEngine.find('#event-calendar');

	if(!collection.length) {
		return;
	}

	loadScript('./dist/default/vendors/mobiscroll/js/mobiscroll.javascript.min.js', {
		callback : () => {
			for(const element of collection) {
				const api = new MobiScheduler(element, {
					multiEvent : {
						id : 1
					},
					mobi : {
						minDate: '',
						maxDate: ''
					}
				});
			}
		}
	});
};

// -------
// Init
// -------

export default init;